/**
 * Scarcity timer for the custom cart drawer (Upcart replacement).
 * Fully client-side, session-based countdown - not a real stock hold.
 * Re-queries the DOM on every tick (not a cached reference) so it survives
 * the drawer's innerHTML being replaced after every AJAX cart update.
 */
(function () {
	var STORAGE_KEY = 'cartDrawerScarcityEndsAt';

	function getEndTime(minutes) {
		var stored = window.sessionStorage.getItem(STORAGE_KEY);
		if (stored) {
			return parseInt(stored, 10);
		}
		var endsAt = Date.now() + minutes * 60 * 1000;
		window.sessionStorage.setItem(STORAGE_KEY, String(endsAt));
		return endsAt;
	}

	function resetEndTime(minutes) {
		var endsAt = Date.now() + minutes * 60 * 1000;
		window.sessionStorage.setItem(STORAGE_KEY, String(endsAt));
		return endsAt;
	}

	function format(ms) {
		var totalSeconds = Math.max(0, Math.floor(ms / 1000));
		var minutes = Math.floor(totalSeconds / 60);
		var seconds = totalSeconds % 60;
		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}

	function tick() {
		var el = document.querySelector('[data-scarcity-timer]');

		if (!el) {
			return;
		}

		var minutes = parseInt(el.dataset.minutes, 10) || 5;
		var expireBehavior = el.dataset.expire || 'hide';
		// In the theme editor, never let the merchant's chosen "hide" behavior
		// make the banner disappear just because a design session ran long -
		// always loop it here so it stays visible/editable. Real storefront
		// behavior (customer-facing) is untouched.
		if (window.Shopify && window.Shopify.designMode) {
			expireBehavior = 'reset';
		}
		var endsAt = getEndTime(minutes);
		var remaining = endsAt - Date.now();

		if (remaining <= 0) {
			if (expireBehavior === 'reset') {
				endsAt = resetEndTime(minutes);
				remaining = endsAt - Date.now();
			} else {
				el.classList.add('is-expired');
				return;
			}
		}

		el.classList.remove('is-expired');

		var textEl = el.querySelector('.cart-drawer-scarcity--text');
		if (textEl) {
			var template = textEl.dataset.template;
			if (!template) {
				template = textEl.textContent;
				textEl.dataset.template = template;
			}
			textEl.innerHTML = template.replace(
				'[timer]',
				'<span class="cart-drawer-scarcity--time">' + format(remaining) + '</span>'
			);
		}
	}

	tick();
	setInterval(tick, 1000);

	/**
	 * Keep the drawer visibly open while editing it in the Shopify theme
	 * customizer. The drawer is hidden by default and only opens via the
	 * cart-icon click handler in app.js - any settings change (image pickers
	 * in particular) causes Shopify to re-render the section's HTML, which
	 * drops the runtime 'active' class along with it. Without this, every
	 * edit makes the drawer appear to "disappear" with no obvious way back.
	 * Shopify.designMode is only true inside the editor, never on the live
	 * storefront, so this has no effect for real customers.
	 */
	if (window.Shopify && window.Shopify.designMode) {
		var openForEditing = function () {
			var drawer = document.getElementById('Cart-Drawer');
			if (drawer) {
				document.body.classList.add('open-cc', 'open-cart');
				drawer.classList.add('active');
			}
		};

		document.addEventListener('shopify:section:load', function (event) {
			if (event.target.querySelector('#Cart-Drawer')) {
				openForEditing();
			}
		});
		document.addEventListener('shopify:section:select', function (event) {
			if (event.target.querySelector('#Cart-Drawer')) {
				openForEditing();
			}
		});
		document.addEventListener('shopify:block:select', function (event) {
			if (event.target.closest && event.target.closest('#Cart-Drawer')) {
				openForEditing();
			}
		});

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', openForEditing);
		} else {
			openForEditing();
		}
	}

	/**
	 * Swap the upsell thumbnail to match the selected variant, same as
	 * Upcart. variant->image data comes from data-variant-images (JSON,
	 * built in Liquid) on the [data-cart-upsell] card - only variants that
	 * actually resolved to an image (their own, or the product's fallback)
	 * are in that map, so a lookup miss just leaves the current image alone
	 * rather than swapping to a blank src.
	 * Delegated on document for the same reason as the click handler below:
	 * the drawer's innerHTML is replaced wholesale on every cart update.
	 */
	document.addEventListener('change', function (event) {
		var select = event.target.closest && event.target.closest('[data-cart-upsell-variant]');
		if (!select || select.tagName !== 'SELECT') {
			return;
		}
		var card = select.closest('[data-cart-upsell]');
		var img = card && card.querySelector('[data-cart-upsell-image]');
		var selectedOption = select.options[select.selectedIndex];
		var variantImages = {};
		try {
			variantImages = JSON.parse(card.dataset.variantImages || '{}');
		} catch (e) {
			return;
		}
		var url = variantImages[select.value];
		if (img && url) {
			img.src = url;
		}
		var price = card.querySelector('.price');
		if (price && selectedOption) {
			var amount = price.querySelector('ins .amount');
			var compare = price.querySelector('del');
			if (amount) {
				amount.textContent = selectedOption.dataset.price || amount.textContent;
			}
			if (selectedOption.dataset.comparePrice) {
				if (!compare) {
					compare = document.createElement('del');
					compare.innerHTML = '<span class="amount"></span>';
					price.insertBefore(compare, price.querySelector('ins'));
				}
				compare.querySelector('.amount').textContent = selectedOption.dataset.comparePrice;
				compare.hidden = false;
			} else if (compare) {
				compare.hidden = true;
			}
		}
	});

	/**
	 * Inline upsell "Add" button - adds the selected variant straight to the
	 * cart (matching Upcart's inline dropdown + Add pattern, not a modal) and
	 * re-renders the drawer + cart bubble in place via the Section Rendering
	 * API, the same sections app.js's CartDrawer class already uses.
	 * Delegated on document since the drawer's innerHTML is replaced wholesale
	 * on every cart update - a directly-bound listener would go stale.
	 */
	document.addEventListener('click', function (event) {
		var button = event.target.closest && event.target.closest('[data-cart-upsell-add]');
		if (!button) {
			return;
		}
		event.preventDefault();
		if (button.classList.contains('loading')) {
			return;
		}

		var card = button.closest('[data-cart-upsell]');
		var variantInput = card && card.querySelector('[data-cart-upsell-variant]');
		var variantId = variantInput && variantInput.value;
		if (!variantId) {
			return;
		}

		button.classList.add('loading');

			fetch(window.theme.routes.cart_add_url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
				Accept: 'application/javascript',
			},
			body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
			})
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Upsell add failed');
					}
					return response.json();
			})
			.then(function () {
				return fetch(
					window.location.pathname + '?sections=cart-drawer,cart-bubble'
				);
			})
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Cart refresh failed');
					}
					return response.json();
			})
			.then(function (sections) {
				var drawer = document.querySelector('#Cart-Drawer');
				var toggle = document.getElementById('cart-drawer-toggle');

				if (drawer && sections['cart-drawer']) {
					var newDrawer = new DOMParser()
						.parseFromString(sections['cart-drawer'], 'text/html')
						.querySelector('.cart-drawer');
					if (newDrawer) {
						drawer.innerHTML = newDrawer.innerHTML;
						drawer.classList.add('active');
						document.body.classList.add('open-cc', 'open-cart');
					}
				}
				if (toggle && sections['cart-bubble']) {
					var newCount = new DOMParser()
						.parseFromString(sections['cart-bubble'], 'text/html')
						.querySelector('.thb-item-count');
					var currentCount = toggle.querySelector('.thb-item-count');
					if (newCount && currentCount) {
						currentCount.innerHTML = newCount.innerHTML;
					}
				}
			})
				.catch(function () {
					button.classList.remove('loading');
					var error = document.querySelector('[data-cart-drawer-error]');
					if (error) {
						error.textContent = error.dataset.defaultMessage;
						error.hidden = false;
						error.focus();
					}
				});
	});
})();
